"use strict";
/* eslint-disable @typescript-eslint/no-magic-numbers -- constants file is the right place for magic numbers! */
Object.defineProperty(exports, "__esModule", { value: true });
exports.lowCreditBalanceThreshold = exports.testCreditGlobalSettings = exports.defaultCreditGlobalSettings = void 0;
const payment_1 = require("../payment");
const structure_1 = require("./structure");
const tokenDivisors_1 = require("./tokenDivisors");
/**
 * Control the cost to our users of various metered services that report usage in tokens.
 * The values are the number of tokens that a single Copilot Credit can pay for. Note that token burn is always
 * rounded-up to the nearest whole value, so there
 * See https://docs.google.com/spreadsheets/d/1v_BhkiWvLnFmI-URtqzTkzHCYjgLxICPvVD3YC0Nz5Y/edit?gid=0#gid=0
 */
exports.defaultCreditGlobalSettings = structure_1.CreditGlobalSettings.parse({
    paidCreditPrice: payment_1.PaidCreditDefaultPrice, // 5 cents per credit
    paidCreditPriceWithUsageMeter: payment_1.PaidCreditMeteredDefaultPrice, // 5 cents per credit, with usage meter
    billingThresholds: {
        amountGte: 25_00, // $25
    },
    applicationSpecificTokenDivisors: tokenDivisors_1.defaultApplicationSpecificTokenDivisors,
    tokenDivisors: tokenDivisors_1.defaultTokenDivisors,
});
/**
 * Test defaults for the global settings, used when LaunchDarkly is unavailable, or the value in LaunchDarkly is invalid
 */
exports.testCreditGlobalSettings = structure_1.CreditGlobalSettings.parse({
    ...exports.defaultCreditGlobalSettings,
    paidCreditPrice: payment_1.PaidCreditTestDefaultPrice,
    paidCreditPriceWithUsageMeter: payment_1.PaidCreditTestMeteredDefaultPrice,
});
/**
 * Ratio of used free credits to total free credits for a period, at which we show a low credit warning for non-paid accounts
 */
exports.lowCreditBalanceThreshold = 0.8;
//# sourceMappingURL=constants.js.map